import {
  BeakerIcon,
  BookOpenIcon,
  BuildingOffice2Icon,
  CalendarIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
  HomeIcon,
  IdentificationIcon,
  MapPinIcon,
  MegaphoneIcon,
  RectangleGroupIcon,
  RectangleStackIcon,
  SquaresPlusIcon,
  TruckIcon,
  UserGroupIcon,
} from "@heroicons/vue/24/outline";

import { usePermissions } from "@/Composables";

export default function adminNavigation() {
  const { hasAnyRole } = usePermissions();

  const navigation = [
    { name: "Dashboard", route: "dashboard.index", icon: HomeIcon, component: "Admin/Dashboard" },
    {
      name: "Blue Book Platform",
      route: "blue-book-platform.index",
      icon: BookOpenIcon,
      component: "BlueBookPlatform/BlueBookProgram/Index",
    },
    {
      name: "Contacts",
      icon: UserGroupIcon,
      children: [
        { name: "MSD Board Members", route: "contacts.msd-board-members.index", component: "Contacts/MsdBoardMembers" },
        { name: "MSD Contacts", route: "contacts.msd-contacts.index", component: "Contacts/MsdContacts" },
        { name: "Member Companies", route: "contacts.member-companies.index", component: "Contacts/MemberCompanies" },
        { name: "Suppliers", route: "contacts.suppliers.index", component: "Contacts/Suppliers" },
        { name: "Rep Groups", route: "contacts.reps.index", component: "Contacts/Reps" },
        {
          name: "My Company Contacts",
          route: "contacts.my-company-contacts.index",
          component: "Contacts/MyCompanyContacts",
        },
        {
          name: "Buyers",
          route: "contacts.buyers.index",
          component: "Contacts/Buyers",
        },
      ],
    },
    // { name: "Contacts", route: "contacts.index", icon: UserGroupIcon, component: "Contacts" },
    { name: "Committees", route: "committees.index", icon: RectangleStackIcon, component: "Committees/Index" },
    {
      name: "Warehouse Programs",
      icon: TruckIcon,
      children: [
        // { name: "Reports", route: "analytics.index", component: "Admin/Analytic/Index" },
        { name: "Catalog", route: "warehouse.catalog.index", component: "Warehouse/Catalog/Index" },
        {
          name: "Private Brands",
          route: "warehouse.private-brands.index",
          component: "Warehouse/PrivateBrands/Index",
        },
        {
          name: "Marketing Assets",
          route: "warehouse.marketing-assets.index",
          component: "Warehouse/MarketingAssets/Index",
        },
        { name: "Item Master", route: "warehouse.item-master.index", component: "Warehouse/ItemMaster/Index" },
        {
          name: "Forecast Database",
          route: "forecasting.index",
          component: "Forecasting/Index",
        },
        // Removed for now
        { name: "Defective Form", route: "warehouse.defective-form.index", download: true },
        { name: "Media Valet", route: "warehouse.media-valet.index", component: "Warehouse/MediaValet/Index" },
        {
          name: "Domo Apps",
          href: "https://msdist.domo.com/app-studio",
          target: "_blank",
          external: true,
        },
      ],
    },
    // {
    //   name: "Events Calendar",
    //   route: "events.calendar.index",
    //   icon: CalendarIcon,
    //   component: "Events/Calendar/Index",
    // },
    ...(hasAnyRole("super admin", "broadcaster")
      ? [
        {
          name: "InLook",
          route: "communications.index",
          icon: MegaphoneIcon,
          component: "InLook",
        },
      ]
      : []),
    {
      name: "Projects",
      route: "projects.index",
      icon: RectangleGroupIcon,
      component: "Projects",
    },
    {
      name: "Stage Gate Projects",
      route: "stage-gate-projects.index",
      icon: BeakerIcon,
      component: "StageGateProjects",
      class: "nav-stage-gate-projects",
    },
    {
      name: "Employee Center",
      icon: IdentificationIcon,
      children: [
        {
          groups: [
            {
              name: "Team Members",
              children: [
                {
                  name: "Fort Worth Team",
                  route: "employee-center.fort-worth.index",
                  component: "EmployeeCenter/FortWorth",
                },
                {
                  name: "Lee's Summit Team",
                  route: "employee-center.lees-summit.index",
                  component: "EmployeeCenter/LeesSummit",
                },
              ],
            },
            {
              name: "Shortcuts",
              children: [
                {
                  name: "Employee Store",
                  href: "https://midstates.rtgstores.com/mid-states-distributing",
                  target: "_blank",
                  external: true,
                },
                {
                  name: "Dynamics 365 Prod",
                  href: "https://msdist.operations.dynamics.com",
                  target: "_blank",
                  external: true,
                },
                {
                  name: "Dynamics 365 Dev",
                  href: "https://mid-uat.sandbox.operations.dynamics.com",
                  target: "_blank",
                  external: true,
                },
                {
                  name: "Dynamics CRM",
                  href: "https://midstates.crm.dynamics.com",
                  target: "_blank",
                  external: true,
                },
                {
                  name: "Dynamics CRM Dev",
                  href: "https://midstatessandbox.crm.dynamics.com",
                  target: "_blank",
                  external: true,
                },
                {
                  name: "Paycom",
                  href: "https://www.paycomonline.net/v4/ee/web.php/app/login",
                  target: "_blank",
                  external: true,
                },
              ],
            },
            {
              name: "Support",
              children: [
                { name: "IT Support", href: "mailto:itsupport@msdist.com", email: true },
                { name: "Facilities Support", href: "mailto:facilities@msdist.com", email: true },
              ],
            },
            {
              name: "HR",
              children: [{ name: "Files", route: "employee-center.files.index", component: "EmployeeCenter/files" }],
            },
          ],
        },
      ],
    },
    {
      name: "Calendar of Events",
      route: "upcoming-events.index",
      component: "UpcomingEvents/Index",
      icon: CalendarIcon,
    },
    { name: "Shows", route: "events.index", icon: CurrencyDollarIcon, component: "Events" },
    { name: "Member Map", route: "locations.index", icon: MapPinIcon, component: "Locations/Index" },
    {
      name: "Company Profiles",
      icon: BuildingOffice2Icon,
      children: [
        { name: "Reports", route: "company-profiles.reports.index", component: "CompanyProfiles/Reports" },
        { name: "Manage Profiles", route: "company-profiles.index", component: "CompanyProfiles/Index" },
        { name: "Manage Questions", route: "company-profiles.questions.index", component: "CompanyProfiles/Questions" },
        {
          name: "Manage Job Responsibilities",
          route: "job-responsibilities.index",
          component: "JobResponsibilities/Index",
        },
      ],
    },
    { name: "Reports", route: "reports.index", icon: ChartBarIcon, component: "Reports/Index" },
    {
      name: "Central Services",
      icon: SquaresPlusIcon,
      defaultOpen: true,
      children: [
        { name: "3E", href: "https://3eco.com", target: "_blank", external: true },
        { name: "Weather Trends", href: "https://weathertrends360.com", target: "_blank", external: true },
        { name: "National Shooting Sports", href: "https://www.nssf.org", target: "_blank", external: true },
      ],
    },
  ];

  return {
    navigation,
  };
}
